import React from "react";
import PropTypes from "kf-proptypes/widgets";
import { OverflowText } from "@widgets/datadisplay/overflowtext";

import styles from "./navdropdown.css";

NavDropDown.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
export function NavDropDown(props) {
  const { children, className } = props;
  return <div className={`${styles.container} ${className}`}>{children}</div>;
}

NavItem.propTypes = {
  key: PropTypes.string,
  title: PropTypes.string,
  active: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string
};
function NavItem(props) {
  const { title, key, children, className } = props;
  const slots = React.Children.map(children, (child) => child);
  const subNav =
    slots && slots.find((child) => child.type === NavDropDown.SubNavItem);
  return (
    <>
      {subNav && (
        <div className={styles.navContainer}>
          <div
            key={key}
            className={`small600 ${styles.navHeader} ${className}`}
          >
            {title}
          </div>
          <div className={`${styles.subNavWrapper}`}>{children}</div>
        </div>
      )}
    </>
  );
}
NavDropDown.NavItem = NavItem;

SubNavItem.propTypes = {
  key: PropTypes.string,
  title: PropTypes.string,
  active: PropTypes.bool,
  count: PropTypes.number,
  id: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node
};
function SubNavItem(props) {
  const {
    title,
    active,
    key,
    count,
    id,
    onClick = () => {},
    className,
    children
  } = props;
  return (
    <div
      id={id || key}
      className={` ellipsis ${styles.subNavItem} ${
        active ? `${styles.active}` : ""
      } ${className}`}
      key={key}
      onClick={() => {
        onClick();
      }}
    >
      <p className={`ellipsis ${styles.subNavTitle}`}>
        <OverflowText>{title}</OverflowText>
        {!!count && <>&nbsp;{`(${count})`}</>}
      </p>
      {children}
    </div>
  );
}
NavDropDown.SubNavItem = SubNavItem;
